/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 16:54:04 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { ReferenceInput, SelectInput, TextInput } from 'react-admin';
import { tabbedFilters } from 'styles';

const SiteFilters = props => {
  const classes = tabbedFilters();
  const { setFilters, organisationId } = props;

  return (
    // Note: we do not use the Filters component here as we would
    // be hitting errors nesting forms inside forms
    <div className={classes.root}>
      <TextInput
        source="site_name"
        label={'resources.Site.fields.name'}
        onChange={value =>
          // must pass second arg to setFilters if resettable: true on input
          // pass in the source name with the "resource_" bit removed
          setFilters(value, 'name')
        }
        options={{ resettable: true }}
      />
      <ReferenceInput
        label={'resources.Site.fields.project'}
        source="site_projectId"
        className={classes.filterFields}
        reference="Project"
        filter={{ organisationId }}
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        onChange={value => setFilters(value)}
        allowEmpty={true}
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
    </div>
  );
};

export default SiteFilters;
